import { configureStore } from '@reduxjs/toolkit';
import {combineReducers} from 'redux';
import appReducer from './_AppStore';


// facon tuto

const rootReducer = combineReducers({
  app: appReducer,
});

const store = configureStore({
  reducer: rootReducer,
  // on rajoute ca pour pouvoir utiliser des trucs non-serializable dans le state, comme des array
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    })
});

// facon JDIAZ

// const reducers = combineReducers({
//   steps: stepsReducer,
// });

// // ?
// const store = configureStore({
//   reducer: reducers,
// });

export default store;
